import { useEffect } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import i18n from "@/i18n";

export const SUPPORTED_LANGS = ["en", "fr", "de", "es", "pt"] as const;
export type Lang = (typeof SUPPORTED_LANGS)[number];

export function useLanguage() {
  const { lang } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const target = lang && SUPPORTED_LANGS.includes(lang as Lang) ? lang : "en";
    if (i18n.language !== target) {
      i18n.changeLanguage(target);
    }
  }, [lang]);

  const currentLang: Lang =
    lang && SUPPORTED_LANGS.includes(lang as Lang) ? (lang as Lang) : "en";

  const switchLanguage = (newLang: Lang) => {
    if (newLang === currentLang) return;
    const parts = location.pathname.split("/").filter(Boolean);
    const rest = parts.slice(1).join("/");
    navigate(`/${newLang}${rest ? `/${rest}` : ""}`);
  };

  return { currentLang, switchLanguage };
}